import { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import ScrollPopup from "./ScrollPopup";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">{children}</main>
      <Footer />
      <ScrollPopup />
    </div>
  );
}
